import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { unauthorizedError } from "../../utils/helpers";
import { setSessionExpired, setTotalPage } from "./globalSlice";
import BroadcastTemplateService from "../../services/api/BroadcastTemplateService";

const Templates = new BroadcastTemplateService();

export const getAllTemplates = createAsyncThunk(
  "templates/getAll",
  async ({ page, limit, name, navigate }, { dispatch }) => {
    try {
      const response = await Templates.getAllTemplates({
        page,
        limit,
        name,
      });
      if (response) {
        dispatch(setTotalPage(response.templates.total));
        return response.templates.data;
      }
      throw new Error("Failed to fetch templates");
    } catch (error) {
      if (error?.response?.status === 401) {
        unauthorizedError(navigate);
        dispatch(setSessionExpired(true));
      } else {
        toast.error(error.data?.error || "Failed to fetch templates");
      }
      throw error;
    }
  }
);

export const createTemplate = createAsyncThunk(
  "templates/create",
  async ({ body, navigate }, { dispatch }) => {
    try {
      const response = await Templates.createTemplate(body);
      toast.success(response?.message || "Template created successfully");
      return response;
    } catch (error) {
      toast.error(error.message);
      if (error?.response?.status === 401) {
        unauthorizedError(navigate);
        dispatch(setSessionExpired(true));
      } else {
        toast.error(error.data?.error || "Failed to create template");
      }
      throw error;
    }
  }
);

const initialState = {
  loading: false,
  templates: null,
  error: null,
  page: 0,
  limit: 10,
};

const broadcastTemplateSlice = createSlice({
  name: "broadcastTemplate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllTemplates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.templates = action.payload;
      })
      .addCase(getAllTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(createTemplate.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createTemplate.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default broadcastTemplateSlice.reducer;
